import React, { useCallback, useEffect, useState } from 'react';

import { todoInvoiceIcon } from '@europrocurement/l2d-icons';
import { useNavigate } from 'react-router';
import { mediaObjectFiltersToElasticQuery, useAchatsService } from '@europrocurement/l2d-domain';
import { WidgetWithAction } from '@europrocurement/l2d-modules';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';

// All

const FacturesATraiter: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const { mediaObjectApi } = useAchatsService();

    const [countOfUnregisteredInvoicesToTreat, setCountOfUnregisteredInvoicesToTreat] =
        useState<string>();

    useEffect(() => {
        mediaObjectApi
            .listMediaObjectMediaObjectCollection(
                mediaObjectFiltersToElasticQuery({
                    search: '',
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        forceInterne: false,
                        available: true,
                        deleted: false,
                        dateDebutTraitementBefore: new Date(new Date().getTime() - 2 * 60 * 1000),
                    },
                    orders: [],
                    xIdSociete: 12,
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfUnregisteredInvoicesToTreat(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [mediaObjectApi]);

    const actionCallback = useCallback(async () => {
        navigate(achatsViewPathResolver('listmediaobject'));
    }, [navigate]);

    return (
        <WidgetWithAction
            title="Factures à traiter"
            icon={todoInvoiceIcon}
            actionMessage="Traiter"
            actionCallback={actionCallback}
            data={countOfUnregisteredInvoicesToTreat}
            color="success"
        />
    );
};

export default FacturesATraiter;
